import styled from '@emotion/styled'
import { Button as MuiButton, Typography } from '@mui/material'
import { spacing, SpacingProps } from '@mui/system'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'

import useT from '@/i18n/useT'

interface ButtonProps extends SpacingProps {
  component?: React.ElementType
  to?: string
  target?: string
}

const Button = styled(MuiButton)<ButtonProps>(spacing)

const Wrapper = styled.div`
  text-align: center;
`

function Page500() {
  const { t } = useT()
  return (
    <Wrapper>
      <Helmet title={t('500.title')} />
      <Typography component="h1" variant="h1" align="center" gutterBottom>
        500
      </Typography>
      <Typography component="h2" variant="h4" align="center" gutterBottom>
        {t('500.subtitle')}
      </Typography>
      <Typography
        component="h2"
        variant="subtitle1"
        align="center"
        gutterBottom
      >
        {t('500.description')}
      </Typography>

      <Button
        component={Link}
        to="/"
        variant="contained"
        color="secondary"
        mt={2}
      >
        {t('500.returnToWebsite')}
      </Button>
    </Wrapper>
  )
}

export default Page500
